<main class="container">
    <div class="row">
        <div class="col">
            <form [formGroup]="form" (ngSubmit)="cadastrar()">
                <h1>Cadastro de Permissões</h1>
                <label id="label-input" for="name">
                    <span>Nome:</span>
                    <input formControlName="vc_nome" class="input" type="text" name="name" id="name">
                </label>
                <label id="label-input" for="descricao">
                    <span>Descrição:</span>
                    <input formControlName="vc_descricao" class="input" type="number" name="descricao" id="descricao">
                </label>
                <label id="label-input">
                    <span>Produto:</span>
                    <select type="number" class="input" formControlName="fk_produto" (ngModelChange)="listarProduto()">
                        <option [ngValue]="produto.sr_id" *ngFor="let produto of produtos">
                          {{produto.vc_nome}}
                        </option>
                      </select>
                </label>
                <div id="buttons">
                    <button class="btn-sucesso" type="submit">Cadastrar</button>
                    <button (click)="cancel()" class="btn-cancelar" type="btn">Cancelar</button>
                </div>
            </form>
        </div>
    </div>
</main>